export interface ITableWithFormDelegate {
    onFileUploadClick?(index: number): any;
}
